import { Component, EventEmitter, Output, OnInit, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DatabaseService } from '../../../services/database.service';
import { AssistantUrlService } from '../../../services/assistant-url.service';
import { ShowlistComponent } from '../../../conponents/list/showlist/showlist.component';
import { DynamicFormComponent, FormFieldConfig } from '../../../conponents/dynamic-form/dynamic-form/dynamic-form.component';
import { FormBuilderComponent } from '../../../conponents/form-builder/form-builder.component';
import { FormTagsComponent } from '../../items/form-tags.component';
import { ApprovalFlowDefinition } from '../../../conponents/items/approval/models/approval-flow-definition.model';
import { ApprovalService } from '../../../conponents/items/approval/services/approval.service';
import { OpanaiService } from '../../../services/openai.service';
import { AzureBlobService } from '../../../services/azure-blob.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../services/global-environment';
import { FormConfigService } from '../../../services/form-config.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { I18nService } from '../../../services/i18n.service';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-form-list-table',
  standalone: true,
  imports: [CommonModule, FormsModule, ShowlistComponent, DynamicFormComponent, FormBuilderComponent, FormTagsComponent, TranslatePipe],
  templateUrl: './form-list-table.component.html',
  styleUrls: ['./form-list-table.component.scss']
})
export class FormListTableComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicFormRef!: DynamicFormComponent;
  @ViewChild('newFormBuilder') newFormBuilder!: FormBuilderComponent;
  @ViewChild('editFormBuilder') editFormBuilder!: FormBuilderComponent;

  data: any[] = [];
  companyid: string = '';

  // 載入狀態變數
  isLoading: boolean = false;       // 控制載入狀態顯示

  // 添加新變數來控制顯示狀態
  showTableView: boolean = true;    // 控制是否顯示表格視圖
  selectedFormName: string = '';    // 當前選中的表單名稱

  // 添加控制表單彈出視窗的變數
  showFormDialog: boolean = false;  // 控制是否顯示表單彈出視窗
  formDialogName: string = '';      // 彈出視窗中的表單名稱
  formid:string = '';

  // 添加新表單對話框相關變數
  showNewFormDialog: boolean = false;
  newFormName: string = '';

  // 表單 AI 助手相關屬性
  formAiMessage: string = '';
  formAiMessages: {role: 'user' | 'assistant', content: string}[] = [];
  formImagePreviews: {url: string, file: File, uploading: boolean}[] = [];
  isFormSending: boolean = false;

  // 預設表單配置 (AI 模式下為空，不包含預設欄位)
  defaultFormConfig: FormFieldConfig[] = [];

  // 表單建構器相關變數
  formBuilderMode: 'ai' | 'manual' = 'ai';  // 表單建構模式：AI模式或手動模式
  manualFormConfig: FormFieldConfig[] = [];  // 手動建構的表單配置

  // 統一的表單配置狀態管理（新增）
  unifiedFormConfig: FormFieldConfig[] = [];  // 統一的表單配置狀態

  // 編輯表單配置相關變數
  showEditFormDialog: boolean = false;
  editingFormConfig: any = null;
  editFormBuilderMode: 'ai' | 'manual' = 'ai';
  editManualFormConfig: FormFieldConfig[] = [];
  editDefaultFormConfig: FormFieldConfig[] = [];

  // 統一的編輯表單配置狀態管理（新增）
  unifiedEditFormConfig: FormFieldConfig[] = [];  // 統一的編輯表單配置狀態

  // 編輯表單 AI 助手相關屬性
  editFormAiMessage: string = '';
  editFormAiMessages: {role: 'user' | 'assistant', content: string}[] = [];
  editFormImagePreviews: {url: string, file: File, uploading: boolean}[] = [];
  isEditFormSending: boolean = false;
  editResponseId: string = '';

  // 搜尋相關變數
  searchType: string = '';
  searchDepartment: string = '';
  searchKeyword: string = '';
  filteredData: any[] = [];

  // 可用的過濾選項
  availableTypes: string[] = [];
  availableDepartments: string[] = [];

  //OpenAI回應的id
  responseid = "";

  // QR Code 相關變數
  showQrModal: boolean = false;
  generatedUrl: string = '';
  qrCodeImage: string = '';
  currentFormName: string = '';

  // 刪除表單相關變數
  isDeletingForm: boolean = false;
  deletingFormId: string = '';

  // 編輯欄位相關變數
  editingFormField: {[formId: string]: {[field: string]: boolean}} = {};
  modifiedForms: Set<string> = new Set();
  hasModifications: boolean = false;

  // 自定義分類相關變數
  customTypeInput: {[formId: string]: string} = {};
  customTypeMode: {[formId: string]: boolean} = {};

  // 選項配置 (移除預設的 typeOptions，改為動態生成)
  checkPeriodOptions: {value: string, label: string}[] = [];

  // 簽核流程配置快取
  formConfigCache: {[formName: string]: FormFieldConfig[]} = {};

  // 表單配置載入狀態追蹤
  formConfigLoading: Set<string> = new Set();
  formConfigLoaded: Set<string> = new Set();

  // 簽核流程詳細資訊顯示相關變數
  showApprovalFlowModal: boolean = false;
  selectedApprovalFlowForm: any = null;
  selectedApprovalFlowConfig: FormFieldConfig | null = null;
  selectedApprovalFlowDefinition: ApprovalFlowDefinition | null = null;
  // 簽核流程定義快取
  approvalFlowDefinitionsCache: ApprovalFlowDefinition[] = [];

  @Output() Showlist = new EventEmitter<string>();
  @Output() fillform = new EventEmitter<string>();

  // TrackBy函數，用於優化表格的變更檢測
  trackByFormName(index: number, form: any): string {
    return form.id || form.formName || index.toString();
  }

  // 根據表單名稱取得對應的表單 ID
  getFormIdByName(formName: string): string {
    const form = this.data.find(f => f.formName === formName);
    return form ? form.id : '';
  }

  constructor(
    private databaseService: DatabaseService,
    private openaiService: OpanaiService,
    private azureBlobService: AzureBlobService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private http: HttpClient,
    private assistantUrlService: AssistantUrlService,
    private formConfigService: FormConfigService,
    private approvalService: ApprovalService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    // 初始化檢查週期選項
    this.initializeCheckPeriodOptions();

    // 訂閱語言變更事件
    this.i18nService.currentLang.subscribe(() => {
      this.initializeCheckPeriodOptions();
    });

    // 取得 environment 中的 companyid
    this.companyid = environment.companyid;
    if (!this.companyid) return;

    // 設定載入狀態為 true
    this.isLoading = true;

    // 呼叫新的 API 取得表單配置資料
    const apiUrl = `${environment.apiUrl}/api/form-manager/get_form_config`;

    this.http.get(apiUrl, {
      params: { companyid: this.companyid }
    }).subscribe({
      next: (response: any) => {

        if (response.success && response.data) {
          // 將 API 回應的 data 陣列設定為元件的 data
          this.data = response.data;

          // 將 dataCount 對應到 filledCount 欄位，保持與原有程式邏輯一致
          this.data = this.data.map(form => ({
            ...form,
            filledCount: form.dataCount || 0
          }));

          // 初始化表單資料
          this.initializeFormData();

          // 初始化過濾後的數據
          this.filteredData = [...this.data];

          // 獲取所有可用的類型和部門，用於下拉選單
          this.extractAvailableOptions();

          // 一次性載入所有表單的配置，避免後續的異步載入問題
          this.loadAllFormConfigs();

          // 載入簽核流程定義快取
          this.loadApprovalFlowDefinitionsCache();

          // 由於新 API 已經包含資料筆數，不需要再呼叫 fetchFormCounts
          // this.fetchFormCounts();

          // 表單資料載入完成後，檢查 URL 參數
          this.checkUrlParameters();
        } else {
          console.error('API 回應格式錯誤:', response);
        }
      },
      error: (error) => {
        console.error('Error fetching form config:', error);
        // 發生錯誤時也要關閉載入狀態
        this.isLoading = false;
      },
      complete: () => {
        // 載入完成，關閉載入狀態
        this.isLoading = false;
        console.log('Form config fetching complete');
      }
    });
  }

  // 檢查URL參數並執行相應動作
  private checkUrlParameters(): void {
    this.route.queryParams.subscribe(params => {
      const model = params['model'];
      const formid = params['formid'];
      const formName = params['formName'];

      // 如果有 model=create 和 formid 參數，自動跳轉到對應表單填寫頁面
      if (model === 'create' && formid) {
        console.log('Direct form access detected:', formid);
        // 延遲執行，確保UI已更新
        setTimeout(() => {
          this.createNewRecord(formName,formid);
        }, 500);
      }
    });
  }

  // 提取所有可用的分類和部門選項
  extractAvailableOptions(): void {
    // 獲取唯一的分類
    const typesSet = new Set<string>();
    this.data.forEach(form => {
      if (form.type) {
        typesSet.add(form.type);
      }
    });
    this.availableTypes = Array.from(typesSet).sort();

    // 獲取唯一的部門
    const deptsSet = new Set<string>();
    this.data.forEach(form => {
      if (form.departments && Array.isArray(form.departments)) {
        form.departments.forEach((dept: string) => {
          deptsSet.add(dept);
        });
      }
    });
    this.availableDepartments = Array.from(deptsSet).sort();
  }

  // 搜尋表單
  // 改進搜尋表單方法，確保記錄數保留
  searchForms(): void {
    // 顯示載入狀態
    this.isLoading = true;

    // 使用 setTimeout 模擬異步搜尋，提供更好的使用者體驗
    setTimeout(() => {
      this.filteredData = this.data.filter(form => {
        // 檢查分類是否符合
        if (this.searchType && form.type !== this.searchType) {
          return false;
        }

        // 檢查部門是否符合
        if (this.searchDepartment && (!form.departments ||
            !form.departments.includes(this.searchDepartment))) {
          return false;
        }

        // 檢查關鍵字是否符合
        if (this.searchKeyword &&
            !form.formName.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
          return false;
        }

        return true;
      });

      // 確保已過濾的資料有正確的記錄數
      console.log(`過濾後有 ${this.filteredData.length} 筆資料`);

      // 手動觸發變更檢測
      this.cdr.detectChanges();

      // 關閉載入狀態
      this.isLoading = false;
    }, 200); // 200ms 延遲以提供視覺回饋
  }

  // 重置搜尋條件
  resetSearch(): void {
    this.searchType = '';
    this.searchDepartment = '';
    this.searchKeyword = '';
    this.filteredData = [...this.data];

    // 手動觸發變更檢測
    this.cdr.detectChanges();
  }

  // 初始化表單資料（不再添加模擬資料）
  initializeFormData(): void {
    // 確保每個表單都有基本的欄位結構
    this.data = this.data.map(form => {
      return {
        ...form,
        // 如果這些欄位不存在，設定預設值（但不設定隨機值）
        checkPeriod: form.checkPeriod || '',
        type: form.type || '',
        departments: form.departments || []
      };
    });
  }

  // 取得各表單被填寫次數的資料
  // 修改 fetchFormCounts 方法，確保 filteredData 同步更新
  fetchFormCounts(): void {
    this.databaseService.getFormCount(this.companyid)
      .subscribe({
        next: (result) => {
          console.log('Form count:', result);
          // 假設 result.items 為 [{ formName, filledCount }, ...]
          const countMap = new Map<string, number>();
          result.items.forEach((item: any) => {
            // 使用 item.formName 而非 item.componentname
            countMap.set(item.formName, item.filledCount);
          });

          // 更新現有物件而非創建新物件，減少變更檢測問題
          this.data.forEach(form => {
            form.filledCount = countMap.get(form.formName) || 0;
          });

          // 同步更新 filteredData
          this.filteredData.forEach(form => {
            form.filledCount = countMap.get(form.formName) || 0;
          });

          // 手動觸發變更檢測
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching form count:', error);
        },
        complete: () => {
          console.log('Form count fetching complete');
        }
      });
  }

  // 修改查看列表方法，切換視圖並設定選擇的表單名稱
  viewFormList(formname: string): void {

    this.selectedFormName = formname;
    this.showTableView = false;
  }

  // 添加返回列表的方法
  backToList(): void {
    this.showTableView = true;
    this.selectedFormName = '';
  }

  // 修改新建表單方法，改為在彈出視窗中顯示
  createNewRecord(formname: string,formid:string): void {
    this.formid = formid;
    // this.fillform.emit(formname); // 不再發送事件
    this.formDialogName = formname;
    this.showFormDialog = true;
  }

  // 新增關閉彈出視窗的方法
  closeFormDialog(): void {
    this.showFormDialog = false;
    this.formDialogName = '';

    // 可選：當表單保存完成後刷新記錄列表
    if (this.selectedFormName) {
      // 如果當前在列表視圖中，可以刷新該表單的記錄
      this.fetchFormCounts();
    }
  }

  // 處理表單提交完成後的回調
  handleFormFinished(): void {
    this.closeFormDialog();

    // 刷新表單計數
    this.fetchFormCounts();
  }

  // 打開新增表單對話框，添加初始 AI 助手消息
  openNewFormDialog(): void {
    this.showNewFormDialog = true;
    this.newFormName = `${this.i18nService.translate('form.list.sample_form_name')}_${this.formatDateTime(new Date())}`;
    document.body.style.overflow = 'hidden';

    // 初始化統一配置狀態
    this.unifiedFormConfig = [];
    this.defaultFormConfig = [];
    this.manualFormConfig = [];

    // 初始化 AI 助手消息
    this.formAiMessages = [{
      role: 'assistant',
      content: this.i18nService.translate('form.list.ai_welcome_message')
    }];

    // 重置 AI 模式為預設
    this.formBuilderMode = 'ai';
  }

  // 關閉新增表單對話框
  closeNewFormDialog(): void {
    this.showNewFormDialog = false;
    // 重置表單相關狀態
    this.resetFormState();
  }

  // 重置表單相關狀態
  resetFormState(): void {
    this.newFormName = '';
    this.formAiMessage = '';
    this.formAiMessages = [];
    this.formImagePreviews = [];
    this.isFormSending = false;
    this.unifiedFormConfig = []; // 重置統一配置
    this.defaultFormConfig = [];
    this.manualFormConfig = [];
    // 其他需要重置的狀態
  }

  // 處理表單保存事件的方法
  onFormSaved(saved: boolean): void {
    if (saved) {
      // 表單保存成功，關閉彈出視窗
      this.closeNewFormDialog();

      // 可選：顯示保存成功的通知
      this.showNotification(this.i18nService.translate('form.list.form_saved_success'));
    }
  }

  // 可選：添加顯示通知的方法
  showNotification(message: string): void {
    // 這裡可以實現一個簡單的通知機制，或使用第三方通知庫
    console.log('通知:', message);
    // 使用 alert 提供即時回饋給使用者
    alert(this.i18nService.translate(message));
  }

  // 處理表單內部的 Showlist 事件
  onFormShowList(formName: string): void {
    this.closeNewFormDialog();
    this.viewFormList(formName);
  }

  // 處理表單內部的 fillform 事件
  onFormFill(formName: string): void {
    this.closeNewFormDialog();
    this.createNewRecord(formName,"");
  }

  // 觸發表單文件選擇
  triggerFormFileUpload(): void {
    const fileInput = document.getElementById('formFileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  // 當用戶選擇文件時
  async onFormFilesSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.files || inputElement.files.length === 0) return;

    // 獲取公司名稱，用於上傳路徑
    const companyName = environment.companyid || 'default';

    for (let i = 0; i < inputElement.files.length; i++) {
      const file = inputElement.files[i];
      const fileType = file.type;

      // 生成本地預覽URL (用於圖片檔案)
      const localPreviewUrl = URL.createObjectURL(file);

      // 添加到預覽陣列
      this.formImagePreviews.push({
        url: localPreviewUrl,
        file: file,
        uploading: true
      });

      const index = this.formImagePreviews.length - 1;

      // 根據檔案類型處理
      if (fileType.startsWith('image/')) {
        try {
          // 圖片檔案：上傳到 Azure Blob Storage
          const fileUrl = await this.azureBlobService.uploadFile(
            file,
            companyName,
            'public' // 訪問權限
          );

          console.log('已上傳圖片到 Azure:', fileUrl);

          // 更新預覽用的 URL 為 Azure 中的 URL
          this.formImagePreviews[index].url = fileUrl;
          this.formImagePreviews[index].uploading = false;
        } catch (error) {
          console.error('上傳圖片到 Azure 失敗:', error);
          this.formImagePreviews[index].uploading = false;
        }
      } else if (fileType === 'application/pdf') {
        // PDF 檔案：保留本地檔案引用，不需上傳到 Azure
        this.formImagePreviews[index].uploading = false;
        console.log('已新增 PDF 檔案:', file.name);
      } else {
        // 其他不支援的檔案類型
        this.formImagePreviews[index].uploading = false;
        console.warn('不支援的檔案類型:', fileType);
      }
    }

    // 清空輸入框值，允許重複選擇同一文件
    inputElement.value = '';
  }

  // 移除表單圖片/檔案
  removeFormImage(index: number): void {
    if (index >= 0 && index < this.formImagePreviews.length) {
      // 釋放本地 URL 資源
      URL.revokeObjectURL(this.formImagePreviews[index].url);
      // 從陣列中移除
      this.formImagePreviews.splice(index, 1);
    }
  }

  // 編輯表單模式：觸發文件選擇
  triggerEditFormFileUpload(): void {
    const fileInput = document.getElementById('editFormFileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  // 編輯表單模式：當用戶選擇文件時
  async onEditFormFilesSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.files || inputElement.files.length === 0) return;

    // 獲取公司名稱，用於上傳路徑
    const companyName = environment.companyid || 'default';

    for (let i = 0; i < inputElement.files.length; i++) {
      const file = inputElement.files[i];
      const fileType = file.type;

      // 生成本地預覽URL (用於圖片檔案)
      const localPreviewUrl = URL.createObjectURL(file);

      // 添加到預覽陣列
      this.editFormImagePreviews.push({
        url: localPreviewUrl,
        file: file,
        uploading: true
      });

      const index = this.editFormImagePreviews.length - 1;

      // 根據檔案類型處理
      if (fileType.startsWith('image/')) {
        try {
          // 圖片檔案：上傳到 Azure Blob Storage
          const fileUrl = await this.azureBlobService.uploadFile(
            file,
            companyName,
            'public' // 訪問權限
          );

          console.log('已上傳圖片到 Azure:', fileUrl);

          // 更新預覽用的 URL 為 Azure 中的 URL
          this.editFormImagePreviews[index].url = fileUrl;
          this.editFormImagePreviews[index].uploading = false;
        } catch (error) {
          console.error('上傳圖片到 Azure 失敗:', error);
          this.editFormImagePreviews[index].uploading = false;
        }
      } else if (fileType === 'application/pdf') {
        // PDF 檔案：保留本地檔案引用，不需上傳到 Azure
        this.editFormImagePreviews[index].uploading = false;
        console.log('已新增 PDF 檔案:', file.name);
      } else {
        // 其他不支援的檔案類型
        this.editFormImagePreviews[index].uploading = false;
        console.warn('不支援的檔案類型:', fileType);
      }
    }

    // 清空輸入框值，允許重複選擇同一文件
    inputElement.value = '';
  }

  // 編輯表單模式：移除圖片/檔案
  removeEditFormImage(index: number): void {
    if (index >= 0 && index < this.editFormImagePreviews.length) {
      // 釋放本地 URL 資源
      URL.revokeObjectURL(this.editFormImagePreviews[index].url);
      // 從陣列中移除
      this.editFormImagePreviews.splice(index, 1);
    }
  }

  // 自動調整表單輸入框高度
  autoResizeFormInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  // 處理表單輸入框按鍵事件
  onFormKeyDown(event: KeyboardEvent): void {
    // 按下 Enter 且沒有按住 Shift 發送消息
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.askFormAi();
    }
  }

  // 發送消息給表單 AI 助手
  askFormAi(): void {

    console.log("askFormAi");

    if (!this.formAiMessage.trim() && this.formImagePreviews.length === 0) return;

    // 添加用戶消息到列表
    this.formAiMessages.push({
      role: 'user',
      content: this.formAiMessage
    });

    // 清空輸入框
    const message = this.formAiMessage;
    this.formAiMessage = '';

    // 設置發送狀態
    this.isFormSending = true;

    // 獲取當前的表單配置（根據當前模式）
    const currentFormConfig = this.getCurrentFormConfig();

    // 準備表單配置的上下文信息（供 AI 使用）
    const contextMessage = this.prepareFormConfigContext(currentFormConfig, this.newFormName, this.formBuilderMode, message);

    // 準備檔案
    const imageAttachments: string[] = [];
    const files: File[] = [];

    // 分離圖片 URL 和 PDF 檔案
    this.formImagePreviews.forEach(preview => {
      if (preview.file.type.startsWith('image/')) {
        // 如果是已上傳的圖片，添加到 imageAttachments
        imageAttachments.push(preview.url);
      } else if (preview.file.type === 'application/pdf') {
        // 如果是 PDF 檔案，添加到 files
        files.push(preview.file);
      }
    });

    // 呼叫 OpenAI API
    this.openaiService.chatwithOpenAI(
      contextMessage, // 使用包含表單配置的完整上下文
      'Form-generator',
      this.responseid,
      this.companyid,
      '',
      '',
      'gpt-4.1-mini',
      32768, //gpt-4.1-nano  //gpt-4o-mini
      imageAttachments, // 已上傳圖片的URL
      files // PDF 檔案
    ).subscribe({
      next: (response) => {
        console.log('AI 回應:', response);

        this.responseid = response.response_id; // 儲存回應 ID

        // 添加 AI 回應到訊息列表 - 僅顯示文字部分
        var content = response.content.replace(/```json\n?|```/g, '').trim();
        let displayContent = response.content;

        // 判斷回應是否為 JSON 字串
        try {
          const responseObj = typeof content === 'string' ? JSON.parse(content) : content;

          // 如果是有效的表單配置對象
          if (responseObj && responseObj.stages && Array.isArray(responseObj.stages)) {
            // 更新表單名稱（如果提供）
            if (responseObj.formName && responseObj.formName.trim()) {
              this.newFormName = responseObj.formName;
            }

            // 將多階段配置轉換為單一配置陣列
            const flattenedConfig = responseObj.stages.reduce((acc: any[], stage: any) => {
              if (stage.config && Array.isArray(stage.config)) {
                // 為每個階段的欄位添加階段資訊
                const stageConfig = stage.config.map((field: any) => ({
                  ...field,
                  stageId: stage.stageId,
                  stageName: stage.stageName
                }));
                acc.push(...stageConfig);
              }
              return acc;
            }, []);

            // 使用扁平化的配置
            this.updateFormConfig(flattenedConfig);
            console.log('成功提取多階段表單配置', flattenedConfig);
            // 分離顯示部分（移除 JSON 配置部分）
            displayContent = '已套用新的表單配置！表單名稱：' + this.newFormName;
          }
          // 如果是傳統的單一配置格式
          else if (responseObj && responseObj.config && Array.isArray(responseObj.config)) {
            // 更新表單名稱（如果提供）
            if (responseObj.formName && responseObj.formName.trim()) {
              this.newFormName = responseObj.formName;
            }

            // 直接使用完整的表單配置
            this.updateFormConfig(responseObj.config);
            console.log('成功提取表單配置', responseObj.config);
            // 分離顯示部分（移除 JSON 配置部分）
            displayContent = '已套用新的表單配置！表單名稱：' + this.newFormName;
          }
        } catch (parseError) {
          console.log('回應不是 JSON 格式，嘗試其他解析方法', parseError);

          // 嘗試從回應文本中解析表單配置
          try {
            // 使用正則表達式尋找回應中的 JSON 配置
            const jsonMatch = content.match(/```json\s*([\s\S]*?)\s*```/) ||
                              content.match(/```\s*([\s\S]*?)\s*```/) ||
                              content.match(/\[\s*\{\s*"type"[\s\S]*?\}\s*\]/);

            if (jsonMatch) {

              const jsonStr = jsonMatch[0].replace(/```json|```/g, '').trim();

              console.log('找到的 JSON 配置:', jsonStr);

              let formConfig;

              try {
                formConfig = JSON.parse(jsonStr);

                // 確認解析出的是有效的表單配置
                if (Array.isArray(formConfig) && formConfig.length > 0) {
                  // 更新表單配置
                  this.updateFormConfig(formConfig);
                  displayContent = '已套用新的表單配置！表單名稱：' + this.newFormName;

                  console.log('成功從 AI 回應文本中提取表單配置', formConfig);
                } else {
                  console.log('從 AI 回應中解析的表單配置格式不正確');
                }
              } catch (jsonError) {
                console.log('解析 JSON 時發生錯誤:', jsonError);
              }
            } else {
              console.log('無法從 AI 回應中提取 JSON 配置');
            }
          } catch (error) {
            console.log('處理 AI 回應時發生錯誤:', error);
          }
        }

        // 添加 AI 訊息到聊天記錄
        this.formAiMessages.push({
          role: 'assistant',
          content: displayContent
        });

        // 清除已處理的圖片預覽
        this.formImagePreviews.forEach(preview => {
          URL.revokeObjectURL(preview.url);
        });
        this.formImagePreviews = [];
      },
      error: (error) => {
        console.error('呼叫 AI 服務時出錯:', error);

        // 添加錯誤訊息
        this.formAiMessages.push({
          role: 'assistant',
          content: '抱歉，處理您的請求時發生錯誤。請稍後再試。'
        });
      },
      complete: () => {
        // 恢復發送狀態
        this.isFormSending = false;

        // 捲動到最底部
        setTimeout(() => {
          const container = document.querySelector('.ai-messages-container');
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        }, 100);
      }
    });
  }

  // 檢查配置中簽核流程元件的數量
  private checkApprovalFlowCount(config: FormFieldConfig[]): number {
    return config.filter(field => field.type === 'approval-flow').length;
  }

  // 驗證配置是否符合簽核流程限制
  private validateApprovalFlowLimit(config: FormFieldConfig[]): boolean {
    return this.checkApprovalFlowCount(config) <= 1;
  }

  // 自動移除多餘的簽核流程元件
  private limitApprovalFlowComponents(config: FormFieldConfig[]): FormFieldConfig[] {
    let approvalFlowFound = false;
    return config.filter(field => {
      if (field.type === 'approval-flow') {
        if (approvalFlowFound) {
          console.warn('移除多餘的簽核流程元件:', field);
          return false; // 移除多餘的簽核流程元件
        }
        approvalFlowFound = true;
      }
      return true;
    });
  }

  // 更新表單配置
  updateFormConfig(newConfig: FormFieldConfig[]): void {
    // 確保 newConfig 是有效的配置
    if (!Array.isArray(newConfig) || newConfig.length === 0) {
      console.error('提供的表單配置無效');
      return;
    }

    try {
      // 1. 預處理配置，確保命名一致性
      let processedConfig = newConfig.map(field => {
        // 從 id 或 name �取有效的標識符
        const baseId = (field.id || field.name || '').toString();

        // 移除特殊字元，替換連字符為底線，以建立有效的控制項名稱
        const safeId = baseId.replace(/[^a-zA-Z0-9_]/g, '_');

        return {
          ...field,
          // 確保 id 和 name 屬性一致，避免控制項不匹配的錯誤
          id: safeId,
          name: safeId
        };
      });

      // 2. 限制簽核流程元件數量最多為一個
      const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
      if (approvalFlowCount > 1) {
        console.warn(`檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
        processedConfig = this.limitApprovalFlowComponents(processedConfig);

        // 顯示使用者通知
        alert(this.i18nService.translate('form.approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }

      // 3. 創建新的陣列引用，觸發變更檢測
      this.defaultFormConfig = [...processedConfig];
      this.unifiedFormConfig = [...processedConfig]; // 同步到統一配置

      // 如果當前是手動模式，也要同步更新手動配置
      if (this.formBuilderMode === 'manual') {
        this.manualFormConfig = [...processedConfig];
        console.log('已同步配置到手動模式:', this.manualFormConfig);
      }

      console.log('表單配置已更新:', this.defaultFormConfig);

      // 3. 如果動態表單元件已經存在，直接更新其配置
      setTimeout(() => {
        if (this.dynamicFormRef) {
          // 更新 configJSON 以同步顯示到文本區域
          this.dynamicFormRef.configJSON = JSON.stringify(this.defaultFormConfig, null, 2);

          // 更新配置屬性，這會觸發 ngOnChanges
          this.dynamicFormRef.config = [...this.defaultFormConfig];

          // 手動調用初始化表單方法以確保表單重建
          if (this.dynamicFormRef.initializeForm) {
            this.dynamicFormRef.initializeForm();
          }

          console.log('已將更新後的配置同步到表單元件');
        }

        // 如果當前是手動模式，也要確保表單建構器更新
        if (this.formBuilderMode === 'manual' && this.newFormBuilder) {
          this.syncFormBuilderConfig(processedConfig);
        }

        // 觸發變更檢測
        this.cdr.detectChanges();
      }, 0);
    } catch (error) {
      console.error('更新表單配置時出錯:', error);
    }
  }

  getCheckPeriodText(period: string): string {
    if (!period) return '';

    const periodMap: {[key: string]: string} = {
      'beforeOperation': '作業前',
      'daily': '每日',
      'weekly': '每週',
      'monthly': '每月',
      'quarterly': '每季',
      'yearly': '每年'
    };

    return periodMap[period] || period;
  }

  // 編輯欄位相關方法
  isFieldEditing(formId: string, field: string): boolean {
    return this.editingFormField[formId]?.[field] || false;
  }

  startEditField(formId: string, field: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    // 關閉其他正在編輯的欄位
    this.closeAllEditFields();

    if (!this.editingFormField[formId]) {
      this.editingFormField[formId] = {};
    }
    this.editingFormField[formId][field] = true;
  }

  stopEditField(formId: string, field: string): void {
    if (this.editingFormField[formId]) {
      this.editingFormField[formId][field] = false;

      // 如果是分類欄位，清理自定義模式
      if (field === 'type') {
        this.exitCustomTypeMode(formId);
      }
    }
  }

  // 關閉所有編輯欄位
  closeAllEditFields(): void {
    Object.keys(this.editingFormField).forEach(formId => {
      Object.keys(this.editingFormField[formId]).forEach(field => {
        this.editingFormField[formId][field] = false;
      });
    });
  }

  // 更新欄位值並標記為已修改
  updateFieldValue(formId: string, field: string, value: any): void {
    const form = this.data.find(f => f.id === formId);
    if (form) {
      form[field] = value;
      this.markFormAsModified(formId);
      this.stopEditField(formId, field);
    }
  }

  // 標記表單為已修改
  markFormAsModified(formId: string): void {
    if (!this.modifiedForms.has(formId)) {
      this.modifiedForms.add(formId);
      this.hasModifications = true;
    }
  }

  // 檢查表單是否被修改過
  isFormModified(formId: string): boolean {
    return this.modifiedForms.has(formId);
  }

  // 取消編輯欄位
  cancelEditField(formId: string, field: string): void {
    this.stopEditField(formId, field);
  }

  // 處理鍵盤事件
  onFieldKeydown(event: KeyboardEvent, formId: string, field: string): void {
    if (event.key === 'Escape') {
      this.cancelEditField(formId, field);
    } else if (event.key === 'Enter' && field !== 'departments') {
      // 對於部門欄位，Enter 鍵由 FormTagsComponent 處理
      this.stopEditField(formId, field);
    }
  }

  // 處理部門標籤變更
  onDepartmentTagsChange(formId: string, tags: string[]): void {
    const form = this.data.find(f => f.id === formId);
    if (form) {
      form.departments = tags;
      this.markFormAsModified(formId);
      // 同步更新過濾資料
      const filteredForm = this.filteredData.find(f => f.id === formId);
      if (filteredForm) {
        filteredForm.departments = tags;
      }
      // 重新提取可用選項
      this.extractAvailableOptions();
    }
  }

  // 處理點擊外部區域關閉編輯
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // 檢查是否點擊在表格外部
    const target = event.target as HTMLElement;
    if (!target.closest('.editable-field') && !target.closest('.field-editor')) {
      // 關閉所有編輯狀態
      Object.keys(this.editingFormField).forEach(formId => {
        Object.keys(this.editingFormField[formId]).forEach(field => {
          if (this.editingFormField[formId][field]) {
            this.stopEditField(formId, field);
          }
        });
      });
    }
  }

  // 切換表單建構模式
  toggleFormBuilderMode(): void {
    console.log(`切換到 ${this.formBuilderMode} 模式`);

    // 在切換模式前，保存當前統一配置狀態
    const currentUnifiedConfig = [...this.unifiedFormConfig];

    if (this.formBuilderMode === 'manual') {
      // 切換到手動模式
      this.formAiMessages = [];
      this.formAiMessage = '';

      // 同步當前配置到手動模式
      this.manualFormConfig = [...currentUnifiedConfig];

      console.log('切換到手動模式，當前配置:', this.manualFormConfig);

      // 強制觸發變更檢測
      this.cdr.detectChanges();

      // 延遲更新表單建構器，確保視圖已切換
      setTimeout(() => {
        if (this.newFormBuilder) {
          this.syncFormBuilderConfig(currentUnifiedConfig);
        }
        // 再次觸發變更檢測，確保表單建構器正確更新
        this.cdr.detectChanges();
      }, 200);
    } else {
      // 切換到 AI 模式
      this.formAiMessages = [{
        role: 'assistant',
        content: this.i18nService.translate('form.list.ai_welcome_message')
      }];

      // 同步當前配置到 AI 模式
      this.defaultFormConfig = [...currentUnifiedConfig];

      // 如果當前有配置，告知 AI 當前的完整表單狀態
      if (currentUnifiedConfig.length > 0) {
        const formDescription = this.formatFormConfigForAI(currentUnifiedConfig);
        this.formAiMessages.push({
          role: 'assistant',
          content: `${formDescription}\n\n我可以幫你進一步優化、修改或添加更多功能。請告訴我你需要什麼調整？`
        });
      }
    }
  }

  // 處理手動表單建構器的配置變更
  onManualConfigChange(config: FormFieldConfig[]): void {
    let processedConfig = [...config];

    // 檢查並限制簽核流程元件數量
    const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
    if (approvalFlowCount > 1) {
      console.warn(`手動建構中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
      processedConfig = this.limitApprovalFlowComponents(processedConfig);

      // 顯示使用者通知
      setTimeout(() => {
        alert(this.i18nService.translate('form.manual_approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }, 100);
    }

    this.manualFormConfig = processedConfig;

    // 在手動模式下，同步到統一配置和其他配置
    if (this.formBuilderMode === 'manual') {
      this.defaultFormConfig = [...processedConfig]; // 創建新的陣列引用
      this.unifiedFormConfig = [...processedConfig]; // 同步到統一配置

      // 同步到動態表單元件（與 AI 模式保持一致）
      setTimeout(() => {
        if (this.dynamicFormRef) {
          // 更新 configJSON 以同步顯示到文本區域
          this.dynamicFormRef.configJSON = JSON.stringify(this.defaultFormConfig, null, 2);

          // 更新配置屬性，這會觸發 ngOnChanges
          this.dynamicFormRef.config = [...this.defaultFormConfig];

          // 手動調用初始化表單方法以確保表單重建
          if (this.dynamicFormRef.initializeForm) {
            this.dynamicFormRef.initializeForm();
          }

          console.log('已將手動建構的配置同步到表單元件');
        }
      }, 0);
    }
  }

  // 處理手動表單建構器的預覽變更
  onManualPreviewChange(config: FormFieldConfig[]): void {
    // 可以在這裡處理即時預覽邏輯
    this.manualFormConfig = config;
  }

  // 獲取當前的表單配置（根據模式）
  getCurrentFormConfig(): FormFieldConfig[] {
    return this.formBuilderMode === 'manual' ? this.manualFormConfig : this.defaultFormConfig;
  }

  // 新增：獲取統一的表單配置
  getUnifiedFormConfig(): FormFieldConfig[] {
    return this.unifiedFormConfig;
  }

  // 新增：統一的預覽配置變更處理
  onUnifiedPreviewConfigChanged(newConfig: FormFieldConfig[]): void {
    console.log('Unified preview config changed:', newConfig);

    // 檢查配置是否真的有變化，避免不必要的更新
    const currentConfigStr = JSON.stringify(this.unifiedFormConfig);
    const newConfigStr = JSON.stringify(newConfig);

    if (currentConfigStr === newConfigStr) {
      console.log('Unified config has not actually changed, skipping update');
      return;
    }

    // 檢查並限制簽核流程元件數量
    let processedConfig = [...newConfig];
    const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
    if (approvalFlowCount > 1) {
      console.warn(`統一配置中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
      processedConfig = this.limitApprovalFlowComponents(processedConfig);

      // 顯示使用者通知
      setTimeout(() => {
        alert(this.i18nService.translate('form.approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }, 100);
    }

    // 更新統一配置狀態
    this.unifiedFormConfig = [...processedConfig];

    // 同步到各個模式的配置
    this.defaultFormConfig = [...processedConfig];
    this.manualFormConfig = [...processedConfig];

    // 根據當前模式同步到對應的建構器
    if (this.formBuilderMode === 'manual' && this.newFormBuilder) {
      // 同步到手動建構器，但要避免循環觸發
      setTimeout(() => {
        this.syncFormBuilderConfig(processedConfig);
      }, 0);
    }
  }

  // 處理來自 ShowlistComponent 的資料更新事件
  onDataUpdated(): void {
    console.log('資料已更新，重新整理表單計數');
    // 重新整理表單計數
    this.fetchFormCounts();
  }

  // 處理記錄新增完成事件
  onRecordAdded(): void {
    console.log('記錄已新增，重新整理表單列表和計數');

    // 關閉表單對話框
    this.closeFormDialog();

    // 確保回到表單列表視圖
    this.showTableView = true;
    this.selectedFormName = '';

    // 重新載入表單列表資料
    this.reloadFormList();

    // 顯示成功提示
    this.showNotification(this.i18nService.translate('form.list.record_added_success'));
  }

  // 重新載入表單列表資料
  reloadFormList(): void {
    // 顯示載入狀態
    this.isLoading = true;

    // 呼叫新的 API 取得表單配置資料
    const apiUrl = `${environment.apiUrl}/api/form-manager/get_form_config`;

    this.http.get(apiUrl, {
      params: { companyid: this.companyid }
    }).subscribe({
      next: (response: any) => {
        console.log('重新載入表單列表:', response);

        if (response.success && response.data) {
          // 將 API 回應的 data 陣列設定為元件的 data
          this.data = response.data;

          // 將 dataCount 對應到 filledCount 欄位，保持與原有程式邏輯一致
          this.data = this.data.map(form => ({
            ...form,
            filledCount: form.dataCount || 0
          }));

          // 初始化表單資料
          this.initializeFormData();

          // 更新過濾後的數據
          this.filteredData = [...this.data];

          // 重新提取可用選項
          this.extractAvailableOptions();

          // 重新載入所有表單配置
          this.loadAllFormConfigs();

          // 重新載入簽核流程定義快取
          this.loadApprovalFlowDefinitionsCache();

          // 由於新 API 已經包含資料筆數，不需要再呼叫 fetchFormCounts
          // this.fetchFormCounts();

          // 手動觸發變更檢測
          this.cdr.detectChanges();
        } else {
          console.error('API 回應格式錯誤:', response);
        }
      },
      error: (error) => {
        console.error('重新載入表單列表失敗:', error);
        // 發生錯誤時也要關閉載入狀態
        this.isLoading = false;
      },
      complete: () => {
        // 載入完成，關閉載入狀態
        this.isLoading = false;
      }
    });
  }

  // 編輯表單配置
  editFormConfig(form: any): void {
    console.log('編輯表單配置:', form);
    this.editingFormConfig = JSON.parse(JSON.stringify(form)); // 深度複製

    // 初始化編輯模式相關變數
    this.editFormBuilderMode = 'ai';
    this.editFormAiMessage = '';
    this.editFormAiMessages = [{
      role: 'assistant',
      content: `你好！我是 AI 表單助手，你目前正在編輯「${form.formName}」表單。請告訴我你想要修改什麼？`
    }];
    this.isEditFormSending = false;
    this.editResponseId = '';

    // 從資料庫載入表單配置，載入完成後再顯示對話框
    this.loadFormConfigFromDatabase(form.formName);
  }

  // 從資料庫載入表單配置
  loadFormConfigFromDatabase(formName: string): void {
    // 建立查詢條件
    const filter: any = {
      companyid: this.companyid,
      formName: formName
    };

    this.databaseService.getDataByQuery(filter, 1, 'form-config')
      .subscribe({
        next: (result) => {
          console.log('載入的表單配置:', result);
          if (result.items && result.items.length > 0) {
            const formConfig = result.items[0];

            // 解析表單配置
            if (formConfig.config) {
              try {
                const parsedConfig = typeof formConfig.config === 'string'
                  ? JSON.parse(formConfig.config)
                  : formConfig.config;

                let configToUse = Array.isArray(parsedConfig) ? parsedConfig : this.defaultFormConfig;

                // 檢查並限制簽核流程元件數量
                const approvalFlowCount = this.checkApprovalFlowCount(configToUse);
                if (approvalFlowCount > 1) {
                  console.warn(`載入的表單配置中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
                  configToUse = this.limitApprovalFlowComponents(configToUse);

                  // 延遲顯示警告，等待對話框開啟後再顯示
                  setTimeout(() => {
                    alert(this.i18nService.translate('form.loaded_approval_flow_limit_warning', {
                      count: approvalFlowCount,
                      removed: approvalFlowCount - 1
                    }));
                  }, 500);
                }

                this.editDefaultFormConfig = [...configToUse];
                this.editManualFormConfig = [...this.editDefaultFormConfig];
                // 初始化統一編輯配置狀態
                this.unifiedEditFormConfig = [...configToUse];

                console.log('成功載入表單配置:', this.editDefaultFormConfig);
              } catch (error) {
                console.error('解析表單配置失敗:', error);
                this.editDefaultFormConfig = [...this.defaultFormConfig];
                this.editManualFormConfig = [...this.defaultFormConfig];
                // 初始化統一編輯配置狀態
                this.unifiedEditFormConfig = [...this.defaultFormConfig];
              }
            } else {
              // 如果沒有配置，使用預設配置
              this.editDefaultFormConfig = [...this.defaultFormConfig];
              this.editManualFormConfig = [...this.defaultFormConfig];
              // 初始化統一編輯配置狀態
              this.unifiedEditFormConfig = [...this.defaultFormConfig];
            }
          } else {
            console.warn('未找到表單配置，使用預設配置');
            this.editDefaultFormConfig = [...this.defaultFormConfig];
            this.editManualFormConfig = [...this.defaultFormConfig];
            // 初始化統一編輯配置狀態
            this.unifiedEditFormConfig = [...this.defaultFormConfig];
          }

          // 配置載入完成後，顯示對話框並觸發變更檢測
          // 添加小延遲確保 Angular 變更檢測正確執行
          setTimeout(() => {
            this.showEditFormDialog = true;
            document.body.style.overflow = 'hidden';

            // 觸發變更檢測，確保 UI 立即更新
            this.cdr.detectChanges();
          }, 10);
        },
        error: (error) => {
          console.error('載入表單配置失敗:', error);
          this.editDefaultFormConfig = [...this.defaultFormConfig];
          this.editManualFormConfig = [...this.defaultFormConfig];
          // 初始化統一編輯配置狀態
          this.unifiedEditFormConfig = [...this.defaultFormConfig];

          // 即使載入失敗，也要顯示對話框（使用預設配置）
          // 添加小延遲確保 Angular 變更檢測正確執行
          setTimeout(() => {
            this.showEditFormDialog = true;
            document.body.style.overflow = 'hidden';

            // 觸發變更檢測
            this.cdr.detectChanges();
          }, 10);
        }
      });
  }

  // 關閉編輯表單配置對話框
  closeEditFormDialog(): void {
    this.showEditFormDialog = false;
    this.editingFormConfig = null;
    this.resetEditFormState();
    document.body.style.overflow = 'auto';
  }

  // 重置編輯表單相關狀態
  resetEditFormState(): void {
    this.editFormBuilderMode = 'ai';
    this.editFormAiMessage = '';
    this.editFormAiMessages = [];
    this.isEditFormSending = false;
    this.editResponseId = '';
    this.editDefaultFormConfig = [];
    this.editManualFormConfig = [];
    this.unifiedEditFormConfig = []; // 重置統一配置

    // 清理編輯表單的圖片預覽
    this.editFormImagePreviews.forEach(preview => {
      URL.revokeObjectURL(preview.url);
    });
    this.editFormImagePreviews = [];
  }

  // 格式化表單配置為人類可讀的描述
  private formatFormConfigForAI(config: FormFieldConfig[]): string {
    if (!config || config.length === 0) {
      return '目前表單為空，沒有任何欄位。';
    }

    // const fieldDescriptions = config.map((field, index) => {
    //   let description = `${index + 1}. ${field.label} (${field.type})`;

    //   if (field.required) {
    //     description += ' [必填]';
    //   }

    //   if (field.placeholder) {
    //     description += ` - 提示文字: "${field.placeholder}"`;
    //   }

    //   if (field.options && field.options.length > 0) {
    //     description += ` - 選項: [${field.options.map(opt => opt.label || opt.value || opt).join(', ')}]`;
    //   }

    //   if (field.content) {
    //     description += ` - 內容: "${field.content}"`;
    //   }

    //   if (field.textAlign) {
    //     description += ` - 對齊: ${field.textAlign}`;
    //   }

    //   if (field.format) {
    //     description += ` - 格式: ${field.format}`;
    //   }

    //   if (field.multiSelect) {
    //     description += ' - 多選模式';
    //   }

    //   return description;
    // });

    return `目前表單包含 ${config.length} 個欄位。\n\n`;
  }

  // 切換編輯表單建構模式
  toggleEditFormBuilderMode(): void {
    console.log(`編輯模式切換到 ${this.editFormBuilderMode} 模式`);

    // 在切換模式前，保存當前統一配置狀態
    const currentUnifiedConfig = [...this.unifiedEditFormConfig];

    if (this.editFormBuilderMode === 'manual') {
      // 切換到手動模式
      this.editFormAiMessages = [];
      this.editFormAiMessage = '';

      // 同步當前配置到手動模式
      this.editManualFormConfig = [...currentUnifiedConfig];

      // 延遲更新表單建構器，確保視圖已切換
      setTimeout(() => {
        if (this.editFormBuilder) {
          this.syncEditFormBuilderConfig(currentUnifiedConfig);
        }
      }, 100);
    } else {
      // 切換到 AI 模式
      this.editFormAiMessages = [{
        role: 'assistant',
        content: `你好！我是 AI 表單助手，你目前正在編輯「${this.editingFormConfig?.formName}」表單。請告訴我你想要修改什麼？`
      }];

      // 同步當前配置到 AI 模式
      this.editDefaultFormConfig = [...currentUnifiedConfig];

      // 如果當前有配置，告知 AI 當前的完整表單狀態
      if (currentUnifiedConfig.length > 0) {
        const formDescription = this.formatFormConfigForAI(currentUnifiedConfig);
        this.editFormAiMessages.push({
          role: 'assistant',
          content: `${formDescription}\n\n我可以幫你修改、添加或優化這些欄位。請告訴我你需要什麼調整？`
        });
      }
    }
  }

  // 自動調整編輯表單輸入框高度
  autoResizeEditFormInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  // 處理編輯表單輸入框按鍵事件
  onEditFormKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.askEditFormAi();
    }
  }

  // 發送消息給編輯表單 AI 助手
  askEditFormAi(): void {

    console.log("askEditFormAi");

    if (!this.editFormAiMessage.trim() && this.editFormImagePreviews.length === 0) return;

    // 添加用戶消息到列表
    this.editFormAiMessages.push({
      role: 'user',
      content: this.editFormAiMessage
    });

    // 清空輸入框
    const message = this.editFormAiMessage;
    this.editFormAiMessage = '';

    // 設置發送狀態
    this.isEditFormSending = true;

    // 獲取當前的表單配置（根據當前模式）
    const currentFormConfig = this.getCurrentEditFormConfig();

    // 準備表單配置的上下文信息（供 AI 使用）
    const contextMessage = this.prepareFormConfigContext(currentFormConfig, this.editingFormConfig?.formName, this.editFormBuilderMode, message);

    // 準備檔案
    const imageAttachments: string[] = [];
    const files: File[] = [];

    // 分離圖片 URL 和 PDF 檔案
    this.editFormImagePreviews.forEach(preview => {
      if (preview.file.type.startsWith('image/')) {
        // 如果是已上傳的圖片，添加到 imageAttachments
        imageAttachments.push(preview.url);
      } else if (preview.file.type === 'application/pdf') {
        // 如果是 PDF 檔案，添加到 files
        files.push(preview.file);
      }
    });

    // 呼叫 OpenAI API
    this.openaiService.chatwithOpenAI(
      contextMessage,
      'c1d2e3f4-a5b6-7890-abcd-ef0123456789',
      this.editResponseId,
      'Quallico',
      '',
      '',
      'gpt-4.1-mini',
      32768,
      imageAttachments, // 已上傳圖片的URL
      files // PDF 檔案
    ).subscribe({
      next: (response) => {
        console.log('編輯表單 AI 回應:', response);

        this.editResponseId = response.response_id;

        var content = response.content.replace(/```json|```/g, '').trim();
        let displayContent = response.content;

        // 嘗試解析 AI 回應中的表單配置
        try {
          const responseObj = typeof content === 'string' ? JSON.parse(content) : content;

          if (responseObj && responseObj.config && Array.isArray(responseObj.config)) {
            this.updateEditFormConfig(responseObj.config);
            displayContent = '已套用修改後的表單配置！';
          }
        } catch (parseError) {
          console.log('回應不是 JSON 格式，嘗試其他解析方法', parseError);

          try {
            const jsonMatch = content.match(/```json\s*([\s\S]*?)\s*```/) ||
                              content.match(/```\s*([\s\S]*?)\s*```/) ||
                              content.match(/\[\s*\{\s*"type"[\s\S]*?\}\s*\]/);

            if (jsonMatch) {
              const jsonStr = jsonMatch[0].replace(/```json|```/g, '').trim();
              console.log('找到的 JSON 配置:', jsonStr);

              let formConfig;
              try {
                formConfig = JSON.parse(jsonStr);
                if (Array.isArray(formConfig) && formConfig.length > 0) {
                  this.updateEditFormConfig(formConfig);
                  displayContent = '已套用修改後的表單配置！';
                  console.log('成功從 AI 回應文本中提取表單配置', formConfig);
                }
              } catch (jsonError) {
                console.log('解析 JSON 時發生錯誤:', jsonError);
              }
            } else {
              console.log('無法從 AI 回應中提取 JSON 配置');
            }
          } catch (error) {
            console.log('處理 AI 回應時發生錯誤:', error);
          }
        }

        // 添加 AI 訊息到聊天記錄
        this.editFormAiMessages.push({
          role: 'assistant',
          content: displayContent
        });
      },
      error: (error) => {
        console.error('呼叫編輯表單 AI 服務時出錯:', error);
        this.editFormAiMessages.push({
          role: 'assistant',
          content: '抱歉，處理您的請求時發生錯誤。請稍後再試。'
        });
      },
      complete: () => {
        this.isEditFormSending = false;

        // 捲動到最底部
        setTimeout(() => {
          const container = document.querySelector('.ai-messages-container');
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        }, 100);
      }
    });
  }

  // 更新編輯表單配置
  updateEditFormConfig(newConfig: FormFieldConfig[]): void {
    if (!Array.isArray(newConfig) || newConfig.length === 0) {
      console.error('提供的編輯表單配置無效');
      return;
    }

    try {
      let processedConfig = newConfig.map(field => {
        const baseId = (field.id || field.name || '').toString();
        const safeId = baseId.replace(/[^a-zA-Z0-9_]/g, '_');

        return {
          ...field,
          id: safeId,
          name: safeId
        };
      });

      // 限制簽核流程元件數量最多為一個
      const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
      if (approvalFlowCount > 1) {
        console.warn(`編輯表單中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
        processedConfig = this.limitApprovalFlowComponents(processedConfig);

        // 顯示使用者通知
        alert(this.i18nService.translate('form.edit_approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }

      this.editDefaultFormConfig = [...processedConfig];
      this.editManualFormConfig = [...processedConfig];
      this.unifiedEditFormConfig = [...processedConfig]; // 同步到統一配置

      console.log('編輯表單配置已更新:', this.editDefaultFormConfig);
    } catch (error) {
      console.error('更新編輯表單配置時出錯:', error);
    }
  }

  // 處理手動編輯表單建構器的配置變更
  onEditManualConfigChange(config: FormFieldConfig[]): void {
    let processedConfig = [...config];

    // 檢查並限制簽核流程元件數量
    const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
    if (approvalFlowCount > 1) {
      console.warn(`編輯手動建構中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
      processedConfig = this.limitApprovalFlowComponents(processedConfig);

      // 顯示使用者通知
      setTimeout(() => {
        alert(this.i18nService.translate('form.edit_manual_approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }, 100);
    }

    this.editManualFormConfig = processedConfig;

    if (this.editFormBuilderMode === 'manual') {
      this.editDefaultFormConfig = [...processedConfig];
      this.unifiedEditFormConfig = [...processedConfig]; // 同步到統一配置

      // 同步到動態表單元件（與新增模式保持一致）
      setTimeout(() => {
        // 手動觸發變更檢測以確保預覽區域更新
        this.cdr.detectChanges();
        console.log('已將編輯手動建構的配置同步到預覽元件');
      }, 0);
    }
  }

  // 處理手動編輯表單建構器的預覽變更
  onEditManualPreviewChange(config: FormFieldConfig[]): void {
    // 可以在這裡處理即時預覽邏輯
    this.editManualFormConfig = config;

    // 確保編輯模式的配置同步更新
    if (this.editFormBuilderMode === 'manual') {
      this.editDefaultFormConfig = [...config];
      this.unifiedEditFormConfig = [...config]; // 同步到統一配置
    }
  }

  // 獲取當前的編輯表單配置
  getCurrentEditFormConfig(): FormFieldConfig[] {
    return this.editFormBuilderMode === 'manual' ? this.editManualFormConfig : this.editDefaultFormConfig;
  }

  // 新增：獲取統一的編輯表單配置
  getUnifiedEditFormConfig(): FormFieldConfig[] {
    return this.unifiedEditFormConfig;
  }

  // 新增：統一的編輯預覽配置變更處理
  onUnifiedEditPreviewConfigChanged(newConfig: FormFieldConfig[]): void {
    console.log('Unified edit preview config changed:', newConfig);

    // 檢查配置是否真的有變化，避免不必要的更新
    const currentConfigStr = JSON.stringify(this.unifiedEditFormConfig);
    const newConfigStr = JSON.stringify(newConfig);

    if (currentConfigStr === newConfigStr) {
      console.log('Unified edit config has not actually changed, skipping update');
      return;
    }

    // 檢查並限制簽核流程元件數量
    let processedConfig = [...newConfig];
    const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
    if (approvalFlowCount > 1) {
      console.warn(`統一編輯配置中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
      processedConfig = this.limitApprovalFlowComponents(processedConfig);

      // 顯示使用者通知
      setTimeout(() => {
        alert(this.i18nService.translate('form.edit_form_approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }, 100);
    }

    // 更新統一配置狀態
    this.unifiedEditFormConfig = [...processedConfig];

    // 同步到各個模式的配置
    this.editDefaultFormConfig = [...processedConfig];
    this.editManualFormConfig = [...processedConfig];

    // 根據當前模式同步到對應的建構器
    if (this.editFormBuilderMode === 'manual' && this.editFormBuilder) {
      // 同步到手動建構器，但要避免循環觸發
      setTimeout(() => {
        this.syncEditFormBuilderConfig(processedConfig);
      }, 0);
    }
  }

  // 處理編輯表單內部的 Showlist 事件
  onEditFormShowList(formName: string): void {
    this.closeEditFormDialog();
    this.viewFormList(formName);
  }

  // 處理編輯表單內部的 fillform 事件
  onEditFormFill(formName: string): void {
    this.closeEditFormDialog();
    this.createNewRecord(formName,"");
  }

  // 儲存編輯後的表單配置
  // saveEditedFormConfig(): void {
  //   if (!this.editingFormConfig) {
  //     console.error('沒有要儲存的表單配置');
  //     return;
  //   }

  //   this.isEditFormSending = true;

  //   // 準備要更新的表單配置
  //   const updatedFormConfig = {
  //     ...this.editingFormConfig,
  //     config: JSON.stringify(this.getCurrentEditFormConfig()),
  //     companyid: this.companyid
  //   };

  //   console.log('準備儲存的表單配置:', updatedFormConfig);

  //   return;

  //   // 使用新的 API 端點
  //   const apiUrl = `${environment.apiUrl}/api/form-manager/save_form_config`;

  //   this.http.post(apiUrl, updatedFormConfig).subscribe({
  //     next: (response: any) => {
  //       console.log('表單配置更新成功:', response);

  //       if (response.success) {
  //         // 更新本地數據
  //         const index = this.data.findIndex(item => item.id === updatedFormConfig.id);
  //         if (index !== -1) {
  //           this.data[index] = { ...updatedFormConfig };
  //         }

  //         // 重新整理過濾後的數據
  //         this.searchForms();

  //         // 關閉對話框
  //         this.closeEditFormDialog();

  //         // 顯示成功訊息
  //         alert(response.message || '表單配置更新成功！');
  //       } else {
  //         console.error('API 回應失敗:', response);
  //         alert(response.message || '更新失敗，請稍後再試。');
  //       }
  //     },
  //     error: (error) => {
  //       console.error('表單配置更新失敗:', error);

  //       // 根據錯誤狀態碼顯示適當的錯誤訊息
  //       let errorMessage = '更新失敗，請稍後再試。';
  //       if (error.status === 400) {
  //         errorMessage = '請求參數錯誤，請檢查表單配置。';
  //       } else if (error.status === 404) {
  //         errorMessage = '找不到要編輯的表單配置。';
  //       } else if (error.status === 409) {
  //         errorMessage = '資料衝突，可能資料已被其他人修改。';
  //       } else if (error.status === 403) {
  //         errorMessage = '沒有權限執行此操作。';
  //       } else if (error.error?.message) {
  //         errorMessage = error.error.message;
  //       }

  //       alert(errorMessage);
  //     },
  //     complete: () => {
  //       this.isEditFormSending = false;
  //     }
  //   });
  // }

  // 調試按鈕點擊事件
  debugButtonClick(action: string, formName: string,formid: string, event: Event): void {
    console.log(`Button clicked - Action: ${action}, FormName: ${formName}`);
    console.log('Event target:', event.target);
    console.log('Current element:', event.currentTarget);

    // 阻止事件冒泡
    event.stopPropagation();
    event.preventDefault();

    // 根據不同的動作執行相對應的函數
    switch (action) {
      case 'view':
        console.log('Executing viewFormList...');
        this.viewFormList(formName);
        break;
      case 'create':
        console.log('Executing createNewRecord...');
        this.createNewRecord(formName,"");
        break;
      case 'edit':
        console.log('Executing editFormConfig...');
        // 需要找到對應的form物件
        const form = this.filteredData.find(f => f.formName === formName);
        if (form) {
          this.editFormConfig(form);
        } else {
          console.error('Form not found:', formName);
        }
        break;
      case 'delete':
        console.log('Executing deleteForm...');
        // 需要找到對應的form物件
        const formToDelete = this.filteredData.find(f => f.formName === formName);
        if (formToDelete) {
          this.deleteForm(formToDelete);
        } else {
          console.error('Form not found for deletion:', formName);
        }
        break;
      default:
        console.error('Unknown action:', action);
    }
  }

  // 生成直連連結
  generateDirectLink(formName: string,id:string): void {
    console.log('Generate direct link for:', formName);

    // 使用 AssistantUrlService 取得 assistantid
    const assistantId = this.assistantUrlService.getAssistantIdFromRoute(this.route) || '251f1d59-092b-49c6-b337-ecc7ac2b3ef7';

    // 取得當前頁面的其他參數
    this.route.queryParams.subscribe(params => {
      const dep_id = params['dep_id'];
      const departmentId = dep_id || '3f1e2b5a-8c47-4d2a-9f1e-7a2c3d4e5f60';

      // 構建完整的直連URL
      const baseUrl = window.location.origin;
      const fullUrl = `${baseUrl}/assistant?id=${assistantId}&dep_id=${departmentId}&component=FormListTableComponent&model=create&formid=${encodeURIComponent(id)}&formName=${encodeURIComponent(formName)}`;

      this.generatedUrl = fullUrl;
      this.currentFormName = formName;

      // 生成QR Code
      this.generateQRCode(fullUrl);

      // 顯示模態框
      this.showQrModal = true;
    });
  }

  // 生成QR Code
  async generateQRCode(url: string): Promise<void> {
    try {
      if (!url) {
        throw new Error('URL 不能為空');
      }

      this.qrCodeImage = await QRCode.toDataURL(url, {
        width: 256,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M'
      });

      console.log('QR Code 生成成功');
    } catch (err) {
      console.error('QR Code 產生失敗:', err);
      this.qrCodeImage = '';
      alert(this.i18nService.translate('form.qrcode_generation_failed'));
    }
  }

  // 複製連結到剪貼簿
  copyLinkToClipboard(): void {
    if (!this.generatedUrl) {
      alert(this.i18nService.translate('form.link_not_generated'));
      return;
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.generatedUrl).then(() => {
        alert(this.i18nService.translate('form.link_copied_to_clipboard'));
      }).catch(err => {
        console.error('複製失敗:', err);
        this.fallbackCopyTextToClipboard();
      });
    } else {
      this.fallbackCopyTextToClipboard();
    }
  }

  // 備用複製方法
  private fallbackCopyTextToClipboard(): void {
    const textArea = document.createElement('textarea');
    textArea.value = this.generatedUrl;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      alert('連結已複製到剪貼簿！');
    } catch (err) {
      console.error('複製失敗:', err);
      alert(this.i18nService.translate('form.copy_failed_manual'));
    }
    document.body.removeChild(textArea);
  }

  // 下載QR Code
  downloadQRCode(): void {
    if (!this.qrCodeImage) {
      alert(this.i18nService.translate('form.qrcode_not_generated'));
      return;
    }

    const link = document.createElement('a');
    link.download = `form-qr-${this.currentFormName}-${new Date().getTime()}.png`;
    link.href = this.qrCodeImage;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // 關閉QR模態框
  closeQrModal(): void {
    this.showQrModal = false;
    this.generatedUrl = '';
    this.qrCodeImage = '';
    this.currentFormName = '';
  }

  // 刪除表單
  deleteForm(form: any): void {
    const confirmMessage = `確定要刪除表單「${form.formName}」嗎？此操作將會刪除表單配置及所有相關資料，且無法復原。`;
    if (confirm(confirmMessage)) {
      this.performDeleteForm(form);
    }
  }

  // 執行刪除表單操作
  performDeleteForm(form: any): void {
    if (!form.id) {
      console.error('表單 ID 不存在，無法刪除');
      alert(this.i18nService.translate('form.delete_failed_no_id'));
      return;
    }

    // 設置載入狀態
    this.isDeletingForm = true;
    this.deletingFormId = form.id;

    // 調用 DatabaseService 的刪除方法
    this.databaseService.deleteForm(this.companyid, form.id)
      .subscribe({
        next: (response) => {
          console.log('表單刪除成功:', response);

          // 從本地數據中移除該表單
          this.data = this.data.filter(f => f.id !== form.id);
          this.filteredData = this.filteredData.filter(f => f.id !== form.id);

          // 重新提取可用選項
          this.extractAvailableOptions();

          // 重新取得各表單填寫次數
          this.fetchFormCounts();

          // 手動觸發變更檢測
          this.cdr.detectChanges();

          // 顯示成功訊息
          alert(this.i18nService.translate('form.delete_success', { formName: form.formName }));
        },
        error: (error) => {
          console.error('刪除表單時發生錯誤:', error);

          // 顯示錯誤訊息
          let errorMessage = '刪除表單時發生錯誤，請稍後再試。';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          alert(this.i18nService.translate('form.delete_failed', { error: errorMessage }));
        },
        complete: () => {
          // 重置載入狀態
          this.isDeletingForm = false;
          this.deletingFormId = '';
        }
      });
  }

  // 處理預覽區域配置變更事件（新增表單時）
  onPreviewConfigChanged(newConfig: FormFieldConfig[]): void {
    console.log('Preview config changed:', newConfig);

    // 檢查配置是否真的有變化，避免不必要的更新
    const currentConfig = this.getCurrentFormConfig();
    const configChanged = JSON.stringify(currentConfig) !== JSON.stringify(newConfig);

    if (!configChanged) {
      console.log('Config has not actually changed, skipping update');
      return;
    }

    // 檢查並限制簽核流程元件數量
    let processedConfig = [...newConfig];
    const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
    if (approvalFlowCount > 1) {
      console.warn(`預覽配置中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
      processedConfig = this.limitApprovalFlowComponents(processedConfig);

      // 顯示使用者通知
      setTimeout(() => {
        alert(this.i18nService.translate('form.preview_approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }, 100);
    }

    // 更新當前的表單配置
    this.defaultFormConfig = [...processedConfig];

    // 根據當前的建構模式同步更新，但避免在手動模式下重複觸發
    if (this.formBuilderMode === 'manual') {
      this.manualFormConfig = [...newConfig];
      // 不要直接觸發表單建構器的配置更新，避免循環觸發
      // this.syncFormBuilderConfig(newConfig);
    }
    // AI 模式下，AI 的配置已經通過 defaultFormConfig 同步
  }

  // 處理編輯模式預覽區域配置變更事件
  onEditPreviewConfigChanged(newConfig: FormFieldConfig[]): void {
    console.log('Edit preview config changed:', newConfig);

    // 檢查配置是否真的有變化，避免不必要的更新
    const currentConfigStr = JSON.stringify(this.editDefaultFormConfig);
    const newConfigStr = JSON.stringify(newConfig);

    if (currentConfigStr === newConfigStr) {
      console.log('Edit config has not actually changed, skipping update');
      return;
    }

    // 檢查並限制簽核流程元件數量
    let processedConfig = [...newConfig];
    const approvalFlowCount = this.checkApprovalFlowCount(processedConfig);
    if (approvalFlowCount > 1) {
      console.warn(`編輯預覽配置中檢測到 ${approvalFlowCount} 個簽核流程元件，將限制為1個`);
      processedConfig = this.limitApprovalFlowComponents(processedConfig);

      // 顯示使用者通知
      setTimeout(() => {
        alert(this.i18nService.translate('form.edit_preview_approval_flow_limit_warning', {
          count: approvalFlowCount,
          removed: approvalFlowCount - 1
        }));
      }, 100);
    }

    // 更新編輯表單配置
    this.editDefaultFormConfig = [...processedConfig];

    // 根據當前的編輯模式同步更新
    if (this.editFormBuilderMode === 'manual') {
      this.editManualFormConfig = [...newConfig];
      // 同步到表單建構器，但要避免循環觸發
      setTimeout(() => {
        this.syncEditFormBuilderConfig(newConfig);
      }, 0);
    }
    // AI 模式下，AI 的配置已經通過 editDefaultFormConfig 同步

    // 手動觸發變更檢測，確保即時預覽區域立即更新
    this.cdr.detectChanges();
  }

  // 同步表單建構器配置（新增表單時）
  private syncFormBuilderConfig(newConfig: FormFieldConfig[]): void {
    // 確保表單建構器存在後再進行同步
    if (this.newFormBuilder) {
      console.log('Syncing form builder with new config:', newConfig);
      // 由於我們已經更新了 manualFormConfig，Angular 的變更檢測會自動觸發 ngOnChanges
      // 如果需要手動觸發，可以使用 ChangeDetectorRef
      this.cdr.detectChanges();
    }
  }

  // 同步編輯表單建構器配置
  private syncEditFormBuilderConfig(newConfig: FormFieldConfig[]): void {
    // 確保編輯表單建構器存在後再進行同步
    if (this.editFormBuilder) {
      console.log('Syncing edit form builder with new config:', newConfig);
      // 由於我們已經更新了 editManualFormConfig，Angular 的變更檢測會自動觸發 ngOnChanges
      this.cdr.detectChanges();
    }
  }

  // 批次儲存所有修改
  saveAllModifications(): void {
    if (this.modifiedForms.size === 0) {
      alert(this.i18nService.translate('form.no_changes_to_save'));
      return;
    }

    if (confirm(`確定要儲存 ${this.modifiedForms.size} 筆表單的修改嗎？`)) {
      // 準備要儲存的修改資料
      const modificationsToSave = Array.from(this.modifiedForms).map(formId => {
        const form = this.data.find(f => f.id === formId);
        if (form) {
          return {
            id: form.id,
            formName: form.formName,
            type: form.type,
            checkPeriod: form.checkPeriod,
            departments: form.departments,
            companyid: this.companyid
          };
        }
        return null;
      }).filter(item => item !== null);

      console.log('準備儲存的修改資料:', modificationsToSave);

      // TODO: 實作實際的 API 呼叫
      // 目前只是模擬儲存成功
      this.saveModificationsToAPI(modificationsToSave);
    }
  }

  // 實際的 API 儲存方法
  private saveModificationsToAPI(modifications: any[]): void {
    // 使用實際的 API 端點儲存表單容器修改
    const apiUrl = `${environment.apiUrl}/api/form-manager/save_form_config`;

    // 為每個修改的表單建立獨立的 API 請求
    const savePromises = modifications.map(modification => {
      const requestData = {
        companyid: this.companyid,
        id: modification.id,
        formName: modification.formName,
        type: modification.type,
        checkPeriod: modification.checkPeriod,
        departments: modification.departments
      };

      return this.http.post(apiUrl, requestData).toPromise();
    });

    // 等待所有請求完成
    Promise.all(savePromises)
      .then((responses: any[]) => {
        console.log('所有修改儲存成功:', responses);

        // 檢查是否所有回應都成功
        const allSuccessful = responses.every(response => response.success);

        if (allSuccessful) {
          // 清除修改標記
          this.modifiedForms.clear();
          this.hasModifications = false;

          // 關閉所有編輯狀態
          this.closeAllEditFields();

          alert(this.i18nService.translate('form.all_changes_saved'));

          // 重新整理表單列表以獲取最新資料
          this.reloadFormList();
        } else {
          // 部分儲存失敗
          const failedResponses = responses.filter(response => !response.success);
          console.error('部分修改儲存失敗:', failedResponses);
          alert(this.i18nService.translate('form.partial_save_failed', { failedCount: failedResponses.length }));
        }
      })
      .catch(error => {
        console.error('儲存修改時發生錯誤:', error);
        alert(this.i18nService.translate('form.save_failed'));
      });
  }

  // 取消所有修改
  cancelAllModifications(): void {
    if (this.modifiedForms.size === 0) {
      alert(this.i18nService.translate('form.no_changes_to_cancel'));
      return;
    }

    if (confirm(`確定要取消 ${this.modifiedForms.size} 筆表單的修改嗎？`)) {
      // 重新載入原始資料
      this.reloadFormList();

      // 清除修改標記和編輯狀態
      this.modifiedForms.clear();
      this.hasModifications = false;
      this.editingFormField = {};

      alert(this.i18nService.translate('form.all_changes_cancelled'));
    }
  }

  // 自定義分類相關方法
  isCustomTypeMode(formId: string): boolean {
    return this.customTypeMode[formId] || false;
  }

  onTypeSelectionChange(formId: string, selectedValue: string): void {
    if (selectedValue === '__custom__') {
      // 進入自定義輸入模式
      this.customTypeMode[formId] = true;
      this.customTypeInput[formId] = '';
    } else {
      // 選擇了預定義的分類
      this.customTypeMode[formId] = false;
      this.updateFieldValue(formId, 'type', selectedValue);
    }
  }

  onTypeSelectBlur(formId: string): void {
    // 如果不在自定義模式下，執行原本的 blur 邏輯
    if (!this.customTypeMode[formId]) {
      this.stopEditField(formId, 'type');
    }
  }

  onCustomTypeBlur(formId: string): void {
    // 自定義輸入框的 blur 事件，延遲處理以允許點擊按鈕
    setTimeout(() => {
      if (!this.customTypeInput[formId] || !this.customTypeInput[formId].trim()) {
        this.cancelCustomType(formId);
      }
    }, 200);
  }

  onCustomTypeKeydown(event: KeyboardEvent, formId: string): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.confirmCustomType(formId);
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.cancelCustomType(formId);
    }
  }

  confirmCustomType(formId: string): void {
    const customType = this.customTypeInput[formId]?.trim();

    if (!customType) {
      alert(this.i18nService.translate('form.enter_category_name'));
      return;
    }

    // 檢查是否已存在相同的分類
    if (this.availableTypes.includes(customType)) {
      alert(this.i18nService.translate('form.category_already_exists'));
      return;
    }

    // 添加新分類到可用選項列表
    this.availableTypes.push(customType);
    this.availableTypes.sort(); // 重新排序

    // 更新表單的分類值
    this.updateFieldValue(formId, 'type', customType);

    // 清理自定義模式狀態
    this.exitCustomTypeMode(formId);

    // 停止編輯
    this.stopEditField(formId, 'type');

    console.log('新增自定義分類:', customType);
  }

  cancelCustomType(formId: string): void {
    // 恢復原始值（不需要特別處理，因為 ngModel 會自動恢復）
    // 清理自定義模式狀態
    this.exitCustomTypeMode(formId);

    // 停止編輯
    this.stopEditField(formId, 'type');
  }

  private exitCustomTypeMode(formId: string): void {
    this.customTypeMode[formId] = false;
    delete this.customTypeInput[formId];
  }

  // 一次性載入所有表單配置，避免後續的異步載入問題
  private loadAllFormConfigs(): void {
    if (!this.data || this.data.length === 0) {
      return;
    }

    console.log('開始載入所有表單配置...');

    const formNames = this.data.map(form => form.formName).filter(name => name && !this.formConfigLoaded.has(name));

    // 並行載入所有表單配置
    formNames.forEach(formName => {
      if (!this.formConfigLoading.has(formName)) {
        this.formConfigLoading.add(formName);

        this.formConfigService.getFormConfig( this.companyid,"",formName).subscribe({
          next: (config: FormFieldConfig[]) => {
            // 處理 config 可能是字串的情況
            let parsedConfig = config;
            if (typeof config === 'string') {
              try {
                parsedConfig = JSON.parse(config);
              } catch (error) {
                console.warn(`解析表單 ${formName} 配置 JSON 失敗:`, error);
                parsedConfig = [];
              }
            }

            // 確保 parsedConfig 是陣列
            const configArray = Array.isArray(parsedConfig) ? parsedConfig : [];

            this.formConfigCache[formName] = configArray;
            this.formConfigLoaded.add(formName);
            this.formConfigLoading.delete(formName);

            // 檢查是否有簽核流程欄位
            const hasApproval = configArray.some(field => field && field.type === 'approval-flow') || false;
            if (hasApproval) {
            }
          },
          error: (error) => {
            console.error(`載入表單 ${formName} 配置失敗:`, error);
            this.formConfigCache[formName] = [];
            this.formConfigLoaded.add(formName);
            this.formConfigLoading.delete(formName);
          }
        });
      }
    });
  }

  // 檢查表單是否有簽核流程配置（優化版，避免異步載入）
  hasApprovalFlow(form: any): boolean {
    if (!form || !form.formName) {
      return false;
    }

    let config = this.formConfigCache[form.formName];

    // 如果配置未載入或載入中，返回 false（避免觸發異步載入）
    if (!config || this.formConfigLoading.has(form.formName)) {
      return false;
    }

    // 檢查 config 是否為字串，如果是的話嘗試解析成 JSON 物件
    if (typeof config === 'string') {
      try {
        config = JSON.parse(config);
      } catch (error) {
        console.warn('Failed to parse form config as JSON:', error);
        return false;
      }
    }

    // 確保 config 是陣列後再調用 some 方法
    if (!Array.isArray(config)) {
      return false;
    }

    // 檢查配置中是否包含 type 為 'approval-flow' 的欄位
    return config.some(field => field && field.type === 'approval-flow');
  }

  // 載入單個表單配置（保留此方法供其他地方使用，但簽核流程檢查不再使用）
  private loadFormConfig(formName: string): void {
    if (!formName || this.formConfigCache[formName] || this.formConfigLoading.has(formName)) {
      return; // 已經載入過或正在載入中
    }

    this.formConfigLoading.add(formName);

    this.formConfigService.getFormConfig(this.companyid,"",formName).subscribe({
      next: (config: FormFieldConfig[]) => {
        this.formConfigCache[formName] = config || [];
        this.formConfigLoaded.add(formName);
        this.formConfigLoading.delete(formName);
        console.log(`單獨載入表單 ${formName} 配置完成`);
      },
      error: (error) => {
        console.error(`載入表單 ${formName} 配置失敗:`, error);
        this.formConfigCache[formName] = [];
        this.formConfigLoaded.add(formName);
        this.formConfigLoading.delete(formName);
      }
    });
  }

  // 取得簽核流程提示文字（優化版）
  getApprovalFlowTooltip(form: any): string {
    if (!form || !form.formName || !this.hasApprovalFlow(form)) {
      return '';
    }

    const config = this.formConfigCache[form.formName];
    const approvalFlowField = config?.find(field => field.type === 'approval-flow');

    if (approvalFlowField) {
      // 如果有指定的簽核流程ID，使用實際的流程名稱
      if (approvalFlowField.approvalFlowId) {
        const flowName = this.getApprovalFlowNameById(approvalFlowField.approvalFlowId);
        if (flowName) {
          return `${flowName}`;
        }
      }

      return `表單「${form.formName}」已設定簽核流程：${approvalFlowField.label || '簽核流程'}，點擊查看詳細資訊`;
    }

    return '此表單已設定簽核流程，點擊查看詳細資訊';
  }

  // 顯示簽核流程詳細資訊（優化版）
  showApprovalFlowDetails(form: any): void {
    if (!form || !form.formName || !this.hasApprovalFlow(form)) {
      console.warn('無法顯示簽核流程詳細資訊：表單無簽核流程配置');
      return;
    }

    const config = this.formConfigCache[form.formName];
    const approvalFlowField = config?.find(field => field.type === 'approval-flow');

    if (approvalFlowField) {
      this.selectedApprovalFlowForm = form;
      this.selectedApprovalFlowConfig = approvalFlowField;

      // 如果有簽核流程ID，載入完整的簽核流程定義
      if (approvalFlowField.approvalFlowId) {
        this.loadApprovalFlowDefinition(approvalFlowField.approvalFlowId);
      } else {
        // 沒有指定的簽核流程ID，直接顯示Modal
        this.selectedApprovalFlowDefinition = null;
        this.showApprovalFlowModal = true;
      }

      console.log('顯示簽核流程詳細資訊:', {
        formName: form.formName,
        approvalFlowField: approvalFlowField,
        approvalFlowId: approvalFlowField.approvalFlowId
      });
    } else {
      console.warn('找不到簽核流程配置欄位');
    }
  }

  // 載入簽核流程定義
  private loadApprovalFlowDefinition(flowId: string): void {
    const assistantId = this.assistantUrlService.getAssistantIdFromRoute(this.route) || 'ALL';

    if (!this.companyid || !assistantId || !flowId) {
      console.warn('載入簽核流程定義失敗：缺少必要參數');
      this.selectedApprovalFlowDefinition = null;
      this.showApprovalFlowModal = true;
      return;
    }

    this.approvalService.getApprovalFlowDefinitionById(flowId, this.companyid, assistantId).subscribe({
      next: (flowDef) => {
        this.selectedApprovalFlowDefinition = flowDef;
        this.showApprovalFlowModal = true;

        console.log('載入簽核流程定義:', {
          flowId: flowId,
          foundFlow: this.selectedApprovalFlowDefinition
        });
      },
      error: (error: any) => {
        console.error('載入簽核流程定義失敗:', error);
        this.selectedApprovalFlowDefinition = null;
        this.showApprovalFlowModal = true;
      }
    });
  }

  // 關閉簽核流程詳細資訊 Modal
  closeApprovalFlowModal(): void {
    this.showApprovalFlowModal = false;
    this.selectedApprovalFlowForm = null;
    this.selectedApprovalFlowConfig = null;
    this.selectedApprovalFlowDefinition = null;
  }

  // 載入簽核流程定義快取
  private loadApprovalFlowDefinitionsCache(): void {
    const assistantId = this.assistantUrlService.getAssistantIdFromRoute(this.route) || 'ALL';

    if (!this.companyid || !assistantId) {
      console.warn('載入簽核流程定義快取失敗：缺少 companyid 或 assistantId');
      this.approvalFlowDefinitionsCache = [];
      return;
    }

    this.approvalService.getApprovalFlowDefinitions(this.companyid, assistantId).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.approvalFlowDefinitionsCache = response.data;
          console.log('載入簽核流程定義快取完成:', response.data.length, '個流程');
        } else {
          console.warn('API 回應成功但無有效資料:', response);
          this.approvalFlowDefinitionsCache = [];
        }
      },
      error: (error) => {
        console.error('載入簽核流程定義快取失敗:', error);
        this.approvalFlowDefinitionsCache = [];
      }
    });
  }

  // 根據流程ID取得流程名稱
  private getApprovalFlowNameById(flowId: string): string {
    const flow = this.approvalFlowDefinitionsCache.find(f => f.id === flowId);
    return flow ? flow.name : '';
  }

  /**
   * 準備表單配置的上下文信息（供 AI 使用）
   * @param config 表單配置
   * @param formName 表單名稱
   * @param builderMode 建構模式
   * @param userMessage 用戶訊息
   * @returns 格式化的上下文信息
   */
  private prepareFormConfigContext(
    config: FormFieldConfig[],
    formName: string,
    builderMode: string,
    userMessage: string
  ): string {

    // 準備包含表單配置的完整上下文信息
    const configJson = JSON.stringify(config, null, 2);
    const contextMessage = `目前表單資訊：
表單名稱：${formName || '未命名表單'}
建構模式：${builderMode === 'manual' ? '手動建構' : 'AI 建構'}

完整配置 JSON：
\`\`\`json
${configJson}
\`\`\`

用戶需求：${userMessage}`;

    console.log('發送給 AI 的表單配置:', config);
    console.log('完整的上下文信息:', contextMessage);

    return contextMessage;
  }

  // 初始化檢查週期選項
  private initializeCheckPeriodOptions(): void {
    this.checkPeriodOptions = [
      {value: 'beforeOperation', label: this.i18nService.translate('form.check_period.beforeOperation')},
      {value: 'daily', label: this.i18nService.translate('form.check_period.daily')},
      {value: 'weekly', label: this.i18nService.translate('form.check_period.weekly')},
      {value: 'monthly', label: this.i18nService.translate('form.check_period.monthly')},
      {value: 'quarterly', label: this.i18nService.translate('form.check_period.quarterly')},
      {value: 'yearly', label: this.i18nService.translate('form.check_period.yearly')}
    ];
  }

  // 格式化日期時間為 yyyymmddhhmmss 格式
  private formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }
}
